import React from 'react';
import { SVGIconProps } from '../../domains/common';

const MicrosoftIcon: React.FC<SVGIconProps> = ({ colored, ...rest }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...rest}>
      <path
        d="M15.2083 15.2056H0V0H15.2083V15.2056Z"
        fill={colored ? '#F35325' : 'currentColor'}
      />
      <path
        d="M32 15.2056H16.7919V0H32V15.2056Z"
        fill={colored ? '#81BC06' : 'currentColor'}
      />
      <path
        d="M15.2078 32H0V16.7947H15.2078V32Z"
        fill={colored ? '#05A6F0' : 'currentColor'}
      />
      <path
        d="M32 32H16.7919V16.7947H32V32Z"
        fill={colored ? '#FFBA08' : 'currentColor'}
      />
    </svg>
  );
};

export default MicrosoftIcon;
